import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';
import BaseCard from './BaseCard';
import StatsInfoRows from './StatsInfoRows';

const useStyles = makeStyles(() => ({
  label: {
    flex: 1,
  },
}));

const DetailedSectionDefaultCard = ({
  route,
  spot,
  active,
  onDoubleClick,
  onClick,
  onStatusChange,
}) => {
  const styles = useStyles();
  return (
    <BaseCard
      route={route}
      spot={spot}
      active={active}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      onStatusChange={onStatusChange}
      detailedStatus
    >
      <StatsInfoRows route={route} labelStyle={styles.label} />
    </BaseCard>
  );
};

export default memo(DetailedSectionDefaultCard);
